// Import model
import { UpdateAddressRequest } from '../models/UpdateAddressRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateAddressRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateAddressRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateAddressRequest instance
   */
  static deserialize(json: string): UpdateAddressRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateAddressRequest instance
   */
  static fromObject(obj: any): UpdateAddressRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateAddressRequest');
    }


    const instance: UpdateAddressRequest = {
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      country: obj['country'] as string | undefined,
      location: obj['location'] as any | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      state: obj['state'] as string | undefined,
      address2: obj['address2'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateAddressRequest instances
   */
  static deserializeArray(json: string): UpdateAddressRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateAddressRequest instance to a JSON string
   */
  static serialize(instance: UpdateAddressRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateAddressRequest instance to a plain object
   */
  static toObject(instance: UpdateAddressRequest): any {
    return {
      'address': instance.address,
      'city': instance.city,
      'country': instance.country,
      'location': instance.location,
      'postalCode': instance.postalCode,
      'state': instance.state,
      'address2': instance.address2,
    };
  }

  /**
   * Serializes an array of UpdateAddressRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateAddressRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
